module.exports = __webpack_public_path__ + "static/media/analytics.37da6b8f.svg";